import React, { useEffect, useState } from "react";
import "../css/Erp.css";
import Header from "../Common/Header";
import Footer from "../Common/Footer";
import Faq from "../Common/Faq";
function Erp() {
  return (
    <>
      <Header />
      <div className="erp-main-wrapper">
        <div className="erp-section-top">
          <div className="common-container">
            <div className="erp-section-top-content">
              <div className="erp-heading-primary">
                Smart ERP System to Manage Businesses,
                <br /> Clients & Invoices — All in One Place
              </div>
              <p className="erp-description">
                Create and manage multiple business profiles, track clients with
                ease, and generate professional invoices in seconds. With
                built-in support for taxation, discounts, and detailed billing,
                our ERP system gives you full control over your operations — no
                spreadsheets, no mess.
              </p>
              <button className="erp-start-btn">Start Now</button>
            </div>
            <div className="erp-image-placeholder">
              <div className="erp-screenshot-placeholder">
                <img src="./images/erp-dashboard.png" alt="dashboard image" />
              </div>
            </div>
          </div>
        </div>
        {/* Section 2 */}
        <div className="erp-section-profile">
          <div className="common-container">
            <div className="erp-section-profile-content">
              <div className="erp-heading-secondary">
                Manage Multiple Business Profiles Seamlessly
                <p className="erp-sub-description">
                  Running more than one business? No problem. Our ERP system
                  lets you create and switch between multiple business profiles
                  effortlessly. Keep data organized, invoices separate, and
                  operations smooth — all under one powerful dashboard designed
                  for multitasking entrepreneurs and growing enterprises.
                </p>
              </div>

              <div className="erp-image-placeholder">
                <div className="erp-profile-screenshot">
                  <img src="./images/erp-profiles.png" alt="dashboard image" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Section 3 */}
        <div className="erp-section-client">
          <div className="common-container">
            <div className="erp-section-client-content">
              <div className="erp-client-heading">
                Create and Manage Client Profiles with Ease
              </div>
              <div className="erp-section-client-below">
                <div className="erp-image-placeholder">
                  <div className="erp-profile-screenshot">
                    <img
                      src="./images/erp-profiles.png"
                      alt="dashboard image"
                    />
                  </div>
                </div>
                <p className="erp-sub-description">
                  Keep every client detail at your fingertips. With our ERP
                  system, you can quickly create individual client profiles,
                  track interactions, manage billing history, and organize
                  contacts — all in one place. Say goodbye to scattered
                  spreadsheets and hello to smart, searchable client management.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Section 4 */}

        <div className="erp-billing-section">
            
          <h2 className="erp-billing-title">
            Create Professional Invoices with Advanced Billing Options
          </h2>

          <p className="erp-billing-description">
            Generate clean, customizable invoices in just a few clicks —
            complete with support for taxes, discounts, and multiple payment
            terms. Whether you're billing clients per project, product, or
            service, our ERP system makes it easy to itemize charges, apply
            regional tax rates, and add custom notes or terms. Stay organized
            with invoice tracking, due date reminders, and a complete history of
            all transactions — so you never miss a payment or lose track of
            revenue.
          </p>

          <div className="erp-billing-content">
            <div className="erp-billing-image">
                <img src="./images/invoice.png" alt="dashboard image" />
            </div>
            <div className="erp-billing-textbox">
         
              <h3 className="erp-billing-subtitle">
                Effortless Invoicing, Built for Business
              </h3>
                 <div className="erp-billing-right">  
              <p className="erp-billing-subtext">
                Create sleek, tax-ready invoices in seconds. Apply discounts,
                track payments, and manage billing — all from one intuitive
                dashboard.
              </p>

              <div className="erp-invoice-icon">
                <img src="./images/invoice-icon.png" alt="invoice icon" />
              </div>
             </div>

            </div>
          </div>
        </div>
      </div>
        <Faq
        endpoint="/api/faq/GetFaqList" // only endpoint, domain comes from .env
        params={{
          currentPage: 1,
          pageSize: 20,
          sortColumn: "FaqId",
          sortDirection: "asc",
          category: "ERP Issues"
        }}
      />
      <Footer />
    </>
  );
}

export default Erp;
